import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AddToBookmarkAccountEndpoint, RemoveFromBookmarkAccountEndpoint } from 'lingo2-api-models';
import { EntityTypeEnum } from 'lingo2-models';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccountBookmarkService {
  readonly http = inject(HttpClient);

  /**
   * Добавить в закладки
   */
  public addBookmark(id: string, type: EntityTypeEnum.account | EntityTypeEnum.school): Observable<boolean> {
    const url = `${environment.account_url}/${AddToBookmarkAccountEndpoint.path}`;
    const body: AddToBookmarkAccountEndpoint.Body = { id, type };
    return this.http[AddToBookmarkAccountEndpoint.method]<AddToBookmarkAccountEndpoint.Response>(url, body, {
      observe: 'body',
    }).pipe(map((responseBody) => responseBody.status));
  }

  /**
   * Удалить из закладок
   */
  public removeBookmark(id: string, type: EntityTypeEnum.account | EntityTypeEnum.school): Observable<boolean> {
    const url = `${environment.account_url}/${RemoveFromBookmarkAccountEndpoint.path}`;
    const body: RemoveFromBookmarkAccountEndpoint.Body = { id, type };
    return this.http[RemoveFromBookmarkAccountEndpoint.method]<RemoveFromBookmarkAccountEndpoint.Response>(url, {
      observe: 'body',
      body,
    }).pipe(map((responseBody) => responseBody.status));
  }
}
